import { Icon } from '@iconify-icon/react';
import classes from './CardIcon.module.scss';
import { CStatus } from 'entities/card/model/types';
import { Typography } from 'antd';
import { useIntl } from 'react-intl';

const overlayIcon = {
  [CStatus.New]: 'mdi:credit-clock-outline',
  [CStatus.None]: 'mdi:credit-clock-outline',
  [CStatus.Personalized]: 'mdi:credit-clock-outline',
  [CStatus.Dispatched]: 'mdi:credit-card-fast-outline',
  [CStatus.SoftBlocked]: 'mdi:snowflake',
  [CStatus.Suspended]: 'mdi:snowflake',
  [CStatus.Blocked]: 'mdi:close-circle',
  [CStatus.Closed]: 'mdi:credit-card-off-outline'
};

const overlayText = {
  [CStatus.New]: 'card.status.ordered',
  [CStatus.None]: 'card.status.ordered',
  [CStatus.Personalized]: 'card.status.ordered',
  [CStatus.Dispatched]: 'card.status.dispatched',
  [CStatus.SoftBlocked]: 'card.status.frozen',
  [CStatus.Suspended]: 'card.status.suspended',
  [CStatus.Blocked]: 'card.status.blocked',
  [CStatus.Closed]: 'card.status.closed'
};

const StatusOverlaySmall: React.FC<{
  status: CStatus;
}> = ({ status }) => {
  return (
    <>
      {status !== CStatus.Active && (
        <div className={classes.overlay}>
          <div className={classes.overlayContent}>
            <Icon className={classes.icon} icon={overlayIcon[status]} width='16' height='16' color='rgb(0, 0, 0)' />
          </div>
        </div>
      )}
    </>
  );
};

const StatusOverlayBig: React.FC<{
  status: CStatus;
}> = ({ status }) => {
  const { formatMessage: t } = useIntl();
  const isClosed = status === CStatus.Closed;

  return (
    <>
      {status !== CStatus.Active && (
        <div className={classes.overlay} style={isClosed ? { zIndex: 100 } : undefined}>
          <div className={classes.overlayContent} style={isClosed ? { zIndex: 101 } : undefined}>
            <Icon 
              icon={overlayIcon[status]} 
              width={isClosed ? '50' : '36'} 
              height={isClosed ? '50' : '36'} 
              color='#000' 
            />
            <Typography.Text
              style={{
                color: '#000',
                fontWeight: 500,
                marginTop: 8,
                fontSize: isClosed ? '14px' : undefined
              }}>
              {t({ id: overlayText[status] })}
            </Typography.Text>
          </div>
        </div>
      )}
    </>
  );
};

const StatusOverlay: React.FC<{
  status: CStatus;
  size?: 's' | 'l';
}> = ({ status, size = 's' }) => {
  if (size === 's') {
    return <StatusOverlaySmall status={status} />;
  } else {
    return <StatusOverlayBig status={status} />;
  }
};

export default StatusOverlay;
